var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"news_details_title"},[_c('span',[_vm._v(_vm._s(_vm.info.title))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.info.addtime))])]),_vm._v(" "),_c('div',{staticClass:"news_details_text",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39fcc918","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/news/_news.vue
// module id = null
// module chunks = 